import { render, staticRenderFns } from "./AttributionRule.vue?vue&type=template&id=dc7e70a2"
import script from "./AttributionRule.vue?vue&type=script&lang=js"
export * from "./AttributionRule.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports